<template>
  <div class="about">
    <section class="content_section light_sec">
      <h2>嗨支付简介</h2>
      <p class="fix_width summary_content">嗨支付为多彩联盟深度合作的支付金流服务网，我们有全新的支付概念。致力于为行业提供充足的收款账号及稳定的支付平台。<br>公开透明费率、稳定多通道收款、支持实时结算。我们希望透过全新的支付理念，彻底解决行业痛点并引领支付行业新的标杆。</p>
    </section>
    <section class="content_section coperation_block">
      <h2>多彩联盟特约合作</h2>
      <div class="fix_width">
        <article>
          <p>「多彩联盟」致力于提供玩家公平诚信的娱乐环境，帮助中小平台成长，从技术到运营再到后期维护给予全方位的服务支持。</p>
          <p>2020年1月，「多彩联盟」与「嗨支付」完成了商业签约合作。「多彩联盟」会员都可以享「嗨支付」折扣费率优惠！</p>
          <span class="tips">马上<a href="https://vue.livelyhelp.chat/chatWindow.aspx?siteId=5000757&planId=314&chatGroup=3" target="_blank">联系客服</a>了解更多。</span>
        </article>
        <div class="side_images">
          <img src="../assets/b2.png">
          <img src="../assets/feat.png">
          <img src="../assets/b1.png">
        </div>
      </div>
    </section>
    <section class="content_section dark_sec">
      <h4>合作伙伴</h4>
      <ul class="partners_block">
        <li><a href="http://www.manycai365.com/" target="_blank"><img src="../assets/a1.png"></a></li>
        <li><a href="https://manycai.tj/" target="_blank"><img src="../assets/a2.png"></a></li>
        <li><a href="http://duocailm.net/" target="_blank"><img src="../assets/a4.png"></a></li>
      </ul>
    </section>
    </div>
</template>

<style lang="less" scoped>
@import '../css/common.less';
.about{
  .summary_content{
    font-weight: 600;
    line-height: 1.67;
    text-align: justify;
  }
  .coperation_block{
    article{
      display: inline-block;
      width: 504px;
      word-break: break-word;
      text-align: justify;
      vertical-align: middle;

      p{
        line-height: 1.67;
        margin: 1em 0 .4em;
      }
      .tips {
        display: block;
        font-weight: 600;
        line-height: 1.67;
        a {color: #d0021b;}
      }
    }
    .side_images{
      display: inline-block;
      margin-left: 20px;
      vertical-align: middle;
      img{
        &:nth-child(1){width: 230px;}
        &:nth-child(2){
          width: 21px;
          margin: 0 10px 0 8px;
        }
        &:nth-child(3){width: 203px;}
        vertical-align: middle;
      }
    }
  }
  .partners_block{
    display: flex;
    flex-direction: row;
    list-style: none;
    justify-content: center;
    align-items: center;
    align-content: center;
    margin-top: 40px;
    li{
      margin: 0 15px;
      :hover img{
        box-shadow: 0 0 18px 2px rgba(208,190,121,0.4);
      }
      img{
        width: 240px;
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1050px) {
  .about{
    .summary_content{
      width: auto;
    }
    .coperation_block{
      article{
        display: block;
        width: 100%;
        p{
          line-height: 1.67;
          margin: 1em 0 .4em;
        }
        .tips {
          display: block;
          font-weight: 600;
          line-height: 1.67;
          a {color: #d0021b;}
        }
      }
      .side_images{
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        margin-top: 1em;
        img{
          &:nth-child(1){width: 12em;}
          &:nth-child(2){
            width: 1.8em;
            margin: 0 1em 0 .8em;
          }
          &:nth-child(3){width: 9em;}
          vertical-align: middle;
        }
      }
    }
    .partners_block{
      display: flex;
      flex-direction: row;
      list-style: none;
      justify-content: center;
      align-items: center;
      align-content: center;
      margin: 2em 0 1em;
      li{
        margin: 0 1em;
        img{
          width: 8.6em;
        }
      }
    }
  }
}
@media screen and (max-width: 767.9px) {
  .about{
    .summary_content{
      font-weight: 600;
      line-height: 1.67;
      text-align: justify;
    }
    .coperation_block{
      article{
        display: block;
        width: 100%;
        word-break: break-word;
        text-align: justify;

        p{
          line-height: 1.67;
          margin: 1em 0 .4em;
        }
        .tips {
          display: block;
          font-weight: 600;
          line-height: 1.67;
          a {color: #d0021b;}
        }
      }
      .side_images{
        display: inline-block;
        margin-left: 0;
        vertical-align: middle;
        margin-top: 1em;
        img{
          &:nth-child(1){width: 36vw;}
          &:nth-child(2){
            width: 5vw;
            margin: 0 1em 0 .8em;
          }
          &:nth-child(3){width: 32vw;}
          vertical-align: middle;
        }
      }
    }
    .partners_block{
      display: flex;
      flex-direction: row;
      list-style: none;
      justify-content: center;
      align-items: center;
      align-content: center;
      flex-wrap: wrap;
      margin-top: 1em;
      li{
        margin: .8em .8em 0;
        img{
          width: 32vw;
        }
      }
    }
  }
}
</style>

<script>
export default {
  name: 'about'
}
</script>
